export const filterWidgetState = <
	T extends Record<string, any>,
	K extends Partial<T>,
>(
	state: T,
	widgetState: K,
): T => {
	return Object.fromEntries(
		Object.keys(state)
			.filter((key) => key in widgetState)
			.map((key) => [key, widgetState[key] as T[typeof key]]),
	) as T;
};
